import React from "react";

interface EmptyIconProps {
  fill?: string;
}

const Empty = ({ fill = "#E8ECEF" }: EmptyIconProps) => {
  return (
    <svg
      width="136"
      height="109"
      viewBox="0 0 136 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.4271 39.8101C71.0471 39.8601 62.5371 39.4701 54.5771 37.2601C46.6171 35.0501 39.5771 30.8801 33.1771 26.0101C28.9871 22.8401 25.1771 20.3201 19.7371 20.7001C14.4181 20.9797 9.33047 22.9642 5.22709 26.3601C-1.69291 32.4201 -0.642905 43.6201 2.11709 51.5001C6.27709 63.3701 18.9371 71.6101 29.6871 76.9801C42.1171 83.1901 55.7671 86.8001 69.4571 88.8701C81.4571 90.6901 96.8671 92.0201 107.257 84.1801C116.807 76.9901 119.427 60.5501 117.087 49.4501C116.518 46.1716 114.772 43.2134 112.177 41.1301C105.467 36.2301 95.4671 39.5001 87.9271 39.6701C85.1771 39.7301 82.2871 39.8001 79.4271 39.8101Z"
        fill="#E8F0FE"
      />
      <path
        d="M38.5674 1V5.3"
        stroke="#75A4FE"
        stroke-width="0.85"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.417 3.15039H40.717"
        stroke="#75A4FE"
        stroke-width="0.85"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.147 86.71V91.01"
        stroke="#75A4FE"
        stroke-width="0.85"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M117.997 88.8604H122.297"
        stroke="#75A4FE"
        stroke-width="0.85"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.07766 68.1397C6.61889 68.1397 7.05766 67.7009 7.05766 67.1597C7.05766 66.6184 6.61889 66.1797 6.07766 66.1797C5.53642 66.1797 5.09766 66.6184 5.09766 67.1597C5.09766 67.7009 5.53642 68.1397 6.07766 68.1397Z"
        fill="#75A4FE"
      />
      <path
        d="M89.5171 5.44047C90.0583 5.44047 90.4971 5.00171 90.4971 4.46047C90.4971 3.91923 90.0583 3.48047 89.5171 3.48047C88.9759 3.48047 88.5371 3.91923 88.5371 4.46047C88.5371 5.00171 88.9759 5.44047 89.5171 5.44047Z"
        fill="#75A4FE"
      />
      <path
        d="M62.3572 108.31C82.6261 108.31 99.0572 107.289 99.0572 106.03C99.0572 104.771 82.6261 103.75 62.3572 103.75C42.0884 103.75 25.6572 104.771 25.6572 106.03C25.6572 107.289 42.0884 108.31 62.3572 108.31Z"
        fill="#E8F0FE"
      />
      <path
        d="M34.0868 12.6797H87.3868C88.7129 12.6797 89.9847 13.2065 90.9224 14.1442C91.8601 15.0818 92.3868 16.3536 92.3868 17.6797V81.0897C92.3868 82.4158 91.8601 83.6875 90.9224 84.6252C89.9847 85.5629 88.7129 86.0897 87.3868 86.0897H27.2568C25.9308 86.0897 24.659 85.5629 23.7213 84.6252C22.7836 83.6875 22.2568 82.4158 22.2568 81.0897V24.6297L34.0868 12.6797Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.1475 43.5801H37.1875V86.7001H92.1475V43.5801Z"
        fill="#E8F0FE"
      />
      <path
        d="M22.2568 24.6297H31.9468C32.5153 24.627 33.0596 24.3994 33.4607 23.9964C33.8617 23.5935 34.0868 23.0482 34.0868 22.4797V12.6797L22.2568 24.6297Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M91.8775 29.8105H37.5175C35.4023 29.8105 33.6875 31.5253 33.6875 33.6405V45.2705C33.6875 47.3858 35.4023 49.1005 37.5175 49.1005H91.8775C93.9927 49.1005 95.7075 47.3858 95.7075 45.2705V33.6405C95.7075 31.5253 93.9927 29.8105 91.8775 29.8105Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.2472 42.8196C46.0919 42.8196 47.5872 41.3243 47.5872 39.4796C47.5872 37.635 46.0919 36.1396 44.2472 36.1396C42.4026 36.1396 40.9072 37.635 40.9072 39.4796C40.9072 41.3243 42.4026 42.8196 44.2472 42.8196Z"
        fill="#75A4FE"
      />
      <path
        d="M54.7472 42.8196C56.5919 42.8196 58.0872 41.3243 58.0872 39.4796C58.0872 37.635 56.5919 36.1396 54.7472 36.1396C52.9026 36.1396 51.4072 37.635 51.4072 39.4796C51.4072 41.3243 52.9026 42.8196 54.7472 42.8196Z"
        fill="#75A4FE"
      />
      <path
        d="M65.2375 42.8196C67.0821 42.8196 68.5775 41.3243 68.5775 39.4796C68.5775 37.635 67.0821 36.1396 65.2375 36.1396C63.3928 36.1396 61.8975 37.635 61.8975 39.4796C61.8975 41.3243 63.3928 42.8196 65.2375 42.8196Z"
        fill="#75A4FE"
      />
      <path
        d="M91.8775 51.1904H37.5175C35.4023 51.1904 33.6875 52.9052 33.6875 55.0204V66.6504C33.6875 68.7657 35.4023 70.4804 37.5175 70.4804H91.8775C93.9927 70.4804 95.7075 68.7657 95.7075 66.6504V55.0204C95.7075 52.9052 93.9927 51.1904 91.8775 51.1904Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.2472 64.2103C46.0919 64.2103 47.5872 62.7149 47.5872 60.8703C47.5872 59.0256 46.0919 57.5303 44.2472 57.5303C42.4026 57.5303 40.9072 59.0256 40.9072 60.8703C40.9072 62.7149 42.4026 64.2103 44.2472 64.2103Z"
        fill="#75A4FE"
      />
      <path
        d="M54.7472 64.2103C56.5919 64.2103 58.0872 62.7149 58.0872 60.8703C58.0872 59.0256 56.5919 57.5303 54.7472 57.5303C52.9026 57.5303 51.4072 59.0256 51.4072 60.8703C51.4072 62.7149 52.9026 64.2103 54.7472 64.2103Z"
        fill="#75A4FE"
      />
      <path
        d="M65.2375 64.2103C67.0821 64.2103 68.5775 62.7149 68.5775 60.8703C68.5775 59.0256 67.0821 57.5303 65.2375 57.5303C63.3928 57.5303 61.8975 59.0256 61.8975 60.8703C61.8975 62.7149 63.3928 64.2103 65.2375 64.2103Z"
        fill="#75A4FE"
      />
      <path
        d="M91.8775 72.5801H37.5175C35.4023 72.5801 33.6875 74.2948 33.6875 76.4101V88.0401C33.6875 90.1553 35.4023 91.8701 37.5175 91.8701H91.8775C93.9927 91.8701 95.7075 90.1553 95.7075 88.0401V76.4101C95.7075 74.2948 93.9927 72.5801 91.8775 72.5801Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.2472 85.5902C46.0919 85.5902 47.5872 84.0948 47.5872 82.2502C47.5872 80.4055 46.0919 78.9102 44.2472 78.9102C42.4026 78.9102 40.9072 80.4055 40.9072 82.2502C40.9072 84.0948 42.4026 85.5902 44.2472 85.5902Z"
        fill="#75A4FE"
      />
      <path
        d="M54.7472 85.5902C56.5919 85.5902 58.0872 84.0948 58.0872 82.2502C58.0872 80.4055 56.5919 78.9102 54.7472 78.9102C52.9026 78.9102 51.4072 80.4055 51.4072 82.2502C51.4072 84.0948 52.9026 85.5902 54.7472 85.5902Z"
        fill="#75A4FE"
      />
      <path
        d="M65.2375 85.5902C67.0821 85.5902 68.5775 84.0948 68.5775 82.2502C68.5775 80.4055 67.0821 78.9102 65.2375 78.9102C63.3928 78.9102 61.8975 80.4055 61.8975 82.2502C61.8975 84.0948 63.3928 85.5902 65.2375 85.5902Z"
        fill="#75A4FE"
      />
      <path
        d="M96.7974 54.17C108.246 54.17 117.527 44.8888 117.527 33.44C117.527 21.9911 108.246 12.71 96.7974 12.71C85.3485 12.71 76.0674 21.9911 76.0674 33.44C76.0674 44.8888 85.3485 54.17 96.7974 54.17Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.518 48.4805L117.038 54.0005"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.42 51.3204L114.706 53.1131C113.935 53.9195 113.964 55.1982 114.771 55.9691L129.661 70.2039C130.468 70.9748 131.746 70.946 132.517 70.1396L134.231 68.3469C135.002 67.5405 134.973 66.2618 134.167 65.4909L119.276 51.2561C118.47 50.4852 117.191 50.514 116.42 51.3204Z"
        fill="white"
        stroke="#1F64E7"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Empty;
